function i(t) {
  let a = 0;
  const n = t.length;
  let r = n - 1;
  for (let e = 0; e < n; e++)
    a += (t[r][0] + t[e][0]) * (t[r][2] - t[e][2]), r = e;
  return Math.abs(a * 0.5);
}
export {
  i as getPolygonArea
};
//# sourceMappingURL=index14.js.map
